import { render } from "./LP_CollegeEvent.vue?vue&type=template&id=09627b3a&scoped=true"
import script from "./LP_CollegeEvent.vue?vue&type=script&lang=js"
export * from "./LP_CollegeEvent.vue?vue&type=script&lang=js"

import "./LP_CollegeEvent.vue?vue&type=style&index=0&id=09627b3a&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09627b3a"]])

export default __exports__